import { HttpEvent, HttpInterceptorFn } from "@angular/common/http";
import { inject } from "@angular/core";
import { TranslocoService } from "@jsverse/transloco";
import { Observable } from "rxjs";

export const LanguageInterceptor: HttpInterceptorFn = (req, next): Observable<HttpEvent<unknown>> => {
    const translocoService = inject(TranslocoService);
    const language = translocoService.getActiveLang();
    const headers = req.headers.set("Accept-Language", language);
    const authReq = req.clone({ headers });
    return next(authReq);
};
